<template>
  <div>
    <van-popup v-model="popShow" :close-on-click-overlay="false">
      <div class="pop-content">
        <div class="pop-content-title">恭喜您获得{{castrolPoint}}积分</div>
        <div class="pop-content-img">
          <img src="../../../assets/images/lottery/castrol+bosth.png">
        </div>
        <CollectCardsPopup v-if="springActivityData && cardsValue"/>
        <div class="pop-content-btn" @click="popClick">继续扫一扫</div>
      </div>

      <div class="pop-close" @click="popClose">
        <img src="../../../assets/images/lottery/off_icon.png" />
      </div>
    </van-popup>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import CollectCardsPopup from './collect-cards-popup'
export default {
  name: 'LotteryPopupCastrol',
  components: {
    CollectCardsPopup
  },
  data () {
    return {
      popShow: false
    }
  },
  computed: {

    ...mapState({
      scanCountMonth: state => state.lottery.scanCountMonth,
      scanCountCurrent: state => state.lottery.scanCountCurrent,
      castrolPoint: state => state.lottery.castrolPoint,
      springActivityData: state => state.lottery.springActivityData,
      cardsValue: state => state.lottery.cardsValue
    })

  },
  methods: {

    popClick () {
      this.$emit('popClick')
      this.popClose()
    },

    popAppear () {
      this.popShow = true
    },

    popClose () {
      this.popShow = false
    }

  }
}
</script>

<style lang="less" scoped>
.van-popup {
  width: 270px;
  min-height: 400px;
  background-color: rgba(0, 0, 0, 0);
  // background: url("../../../assets/images/lottery/pop_bg2.png") no-repeat;
  // background-size: 100% auto;
  .pop-content {
    padding: 30px 10px 30px 10px;
    text-align: center;
    border-radius: 20px;
    background-color: #fff;
    .pop-content-title {
      font-weight: bold;
      font-size: 18px;
    }
    .pop-content-img {
      width: 190px;
      height: 106px;
      margin: 10px auto;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .pop-content-result {
      color: #666;
      font-size: 12px;
      .text-red {
        color: #ed4836
      }
    }
    .pop-content-btn {
      width: 178px;
      height: 50px;
      background-image: url('../../../assets/images/lottery/scan_btn.png');
      background-size: 100%;
      border-radius: 10px;
      text-align: center;
      line-height: 50px;
      color: #2c535d;
      font-weight: bold;
      font-size: 20px;
      margin: 10px auto;
    }
  }
  .pop-close {
    width: 39px;
    height: 39px;
    margin: 32px auto 0 auto;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
